import React, { useEffect, useState } from 'react';
import { Dialog } from 'primereact/dialog';
import Form from 'react-bootstrap/Form';
import { useDropzone } from 'react-dropzone';
import { RadioButton } from "primereact/radiobutton";
import Loader from '../loader/loader'
import ReactQuill from "react-quill";

// Icons
import Gallery from '../../assets/icons/gallery.svg';
import Trash from '../../assets/icons/trash.svg';
import Upload from '../../assets/icons/upload.svg';

import useToastNotification from '../../hooks/useToastNotification';
import { AttachFileCreate, AttachFileDelete, UpdateFoundUs, GetFoundUs, SearchFoundUs, baseUrl } from '../../utils/api';

function Banner() {
    const { showError, showSuccess } = useToastNotification();
    const [text, setText] = useState("");
    const [data, setData] = useState([]);
    const [visibleImageUpload, setVisibleImageUpload] = useState(false);
    const [uploadedFiles, setUploadedFiles] = useState([]); // Files with preview
    const [defaultImg, setDefaultImg] = useState(null);
    const [loading, setLoading] = useState(false);

    const { getRootProps, getInputProps } = useDropzone({
        onDrop: (acceptedFiles) => {
            const newFiles = acceptedFiles.map((file) => ({
                file,
                preview: URL.createObjectURL(file),
            }));

            setUploadedFiles((prev) => [...prev, ...newFiles]);
            setVisibleImageUpload(false);
            document.body.style.overflow = 'auto'; // فعال کردن مجدد اسکرول

        },
        accept: 'image/*',
        maxFiles: 2,
    });
    const fetchData = async () => {
        setLoading(true);
        try {
            const response = await SearchFoundUs({
                description: "",
                pageSize: 0,
                pageIndex: 0,
            });
            const items = response.data.data.items || [];
            setData(items);

            if (items.length > 0) {
                setText(items[0].title);
                const images = items[0].images.map((img) => ({
                    preview: baseUrl + 'io/112x112/' + img.url,
                    file: null,
                    imageId: img.id,
                    id: items[0].id

                }));
                setUploadedFiles(images);
            }
        } catch (error) {
            showError("خطا در دریافت اطلاعات لیست");
        } finally {
            setLoading(false);
        }
    };
    useEffect(() => {


        fetchData();
    }, []);

    const handleRemoveImage = async (index, imageId) => {
        console.log(imageId)
        setUploadedFiles((prev) => prev.filter((_, i) => i !== index));
        await AttachFileDelete({
            id: imageId,
            // id: id
        });
    };

    const handleFileUpload = async (file, id, isDefault) => {
        const formData = {
            filsBase64: await toBase64(file),
            sourceId: id,
            isDefault: isDefault,
        };

        try {
            await AttachFileCreate(formData);
        } catch (error) {
            console.error('Upload error:', error);
            throw error;
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!text.trim()) {
            return showError("وارد کردن متن الزامی است");
        }

        setLoading(true);
        try {
            if (data.length > 0) {
                const item = data[0];

                await UpdateFoundUs({ id: item.id, title: text });

                if (data[0]?.images > 2) {
                    const previousImages = data[0]?.images || [];
                    for (const img of previousImages) {
                        await AttachFileDelete({
                            id: img.id
                        }); // حذف تصویر قدیمی
                    }
                }


                for (let i = 0; i < uploadedFiles.length; i++) {
                    if (uploadedFiles[i].file) {
                        await handleFileUpload(uploadedFiles[i].file, item.id, i === defaultImg);
                    }
                }

                showSuccess("اطلاعات با موفقیت به‌روزرسانی شد");
                fetchData()
            }
        } catch (error) {
            showError("خطا در به‌روزرسانی اطلاعات");
        } finally {
            setLoading(false);
        }
    };

    const toBase64 = (file) => new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result.split(",")[1]);
        reader.onerror = reject;
    });

    const quillModules = {
        toolbar: [
            [{ 'header': '1' }, { 'header': '2' }, { 'font': [] }],  // Headers & Fonts
            [{ 'size': ['6px', '8px', '10px', '12px', '14px', '16px', '18px', '20px', '22px', '24px', '26px', '28px', '30px', '32px', '34px', '36px', '40px', '44px', '48px', '54px', '60px', '72px', '80px'] }],  // Custom font sizes
            ['bold', 'italic', 'underline', 'strike'],  // Formatting options
            ['blockquote', 'code-block'],  // Blockquote and code block
            [{ 'list': 'ordered' }, { 'list': 'bullet' }],  // Lists
            [{ 'indent': '-1' }, { 'indent': '+1' }],  // Indentation
            [{ 'direction': 'rtl' }],  // Text direction (RTL)
            [{ 'align': [] }],  // Text alignment
            [{ 'color': [] }, { 'background': [] }],  // Text and background colors
            ['link', 'image', 'video'],  // Inserting links, images, and videos
            [{ 'script': 'sub' }, { 'script': 'super' }],  // Subscript/Superscript
            ['clean']  // Remove formatting
        ]
    };
    const quillFormats = [
        'header', 'font', 'size', 'bold', 'italic', 'underline', 'strike',
        'blockquote', 'code-block', 'list', 'bullet', 'indent',
        'link', 'image', 'video', 'align', 'color', 'background', 'direction'
    ];
    return (
        <>
            <div className="d-flex align-items-center gap-3 flex-wrap">
                {uploadedFiles.map((image, index) => (
                    <div key={index} className="upload-file-btn">
                        <img src={image.preview} alt="Uploaded preview" className="image-preview" />
                        <div className="upload-file-btn-bottom">
                            <div>
                                <img src={Trash} alt="" onClick={() => handleRemoveImage(index, image.imageId)} />
                            </div>
                        </div>
                    </div>
                ))}

                {uploadedFiles.length < 2 && (
                    <div className="upload-file-btn" onClick={() => {
                        setVisibleImageUpload(true)
                        document.body.style.overflow = 'hidden'; // غیرفعال کردن اسکرول

                    }}>
                        <img src={Gallery} alt="" />
                        <h6 className="fw-500 text-[#669D24] text-sm">انتشار تصویر</h6>
                    </div>
                )}
            </div>

            <Form className="mt-3" onSubmit={handleSubmit}>
                <Form.Group className="mb-3" controlId="exampleForm.ControlTextarea1">
                    <Form.Label>متن مورد نظر را وارد کنید.</Form.Label>
                    <ReactQuill
                        theme="snow"
                        value={text}
                        onChange={setText}
                        modules={quillModules}
                        formats={quillFormats}
                        style={{ minHeight: '200px' }}
                    />
                    {/* <Form.Control
                        as="textarea"
                        rows={3}
                        style={{ minHeight: '100px' }}
                        placeholder="متن ..."
                        value={text}
                        onChange={(e) => setText(e.target.value)}
                    /> */}
                </Form.Group>
                <div className="w-100 d-flex justify-content-end">
                    <button type="submit" disabled={loading} className="btn btn-primary">ثبت{loading === true && <Loader />}</button>

                </div>
            </Form>

            <Dialog
                header="انتشار تصویر"
                visible={visibleImageUpload}
                maximizable
                style={{ width: '40vw' }}
                onHide={() => {
                    setVisibleImageUpload(false)
                    document.body.style.overflow = 'auto'; // فعال کردن مجدد اسکرول

                }}
            >
                <div className="upload-box mt-4 mb-0 flex-1" {...getRootProps()} style={{ borderRadius: '8px', minHeight: '112px', minWidth: '112px' }}>
                    <input {...getInputProps()} />
                    <div>
                        <img src={Upload} alt="" className="mx-auto" />
                        <p className="text-xs mt-2 font-medium">تصویر مورد نظر را از این قسمت وارد کنید.</p>
                        <h6 className='text-[10px]'>بهترین ابعاد: 290 * 290</h6>

                    </div>
                </div>
            </Dialog>
        </>
    );
}

export default Banner;
